import { Component, Input, OnChanges, SimpleChanges, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-authenticated-iframe-wrapper',
  templateUrl: './authenticated-iframe-wrapper.component.html',
  styleUrls: ['./authenticated-iframe-wrapper.component.css']
})
export class AuthenticatedIframeWrapperComponent implements OnChanges, OnInit, OnDestroy {
  @Input() src: string = null;
  @Input() height: string = null;
  @Input() width: string = null;

  safeUrl: SafeResourceUrl = null;
  private reloadInterval: any;

  constructor(
    private sanitizer: DomSanitizer,
    public auth: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {

    if (!this.src) {
      this.src = this.route.snapshot.data['src'] || '';
    }
    if (!this.height) {
      this.height = this.route.snapshot.data['height'] || '600px';
    }
    if (!this.width) {
      this.width = this.route.snapshot.data['width'] || '100%';
    }
    // Reload every hour (3600000 ms)
    this.reloadInterval = setInterval(() => {
      this.reloadIframe();
    }, 12 * 60 * 60 * 1000); // 12 hours
    this.reloadIframe(); // Initial load
  }

  ngOnDestroy(): void {
    if (this.reloadInterval) {
      clearInterval(this.reloadInterval);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.reloadIframe();
  }

  private reloadIframe(): void {
    this.auth.getToken().then((token: string) => {
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.auth.getToken() ? this.appendToken(this.src, token) : this.src
      );
    });
  }

  private appendToken(url: string, token: string): string {
    if (!token) return url;
    const separator = url.includes('?') ? '&' : '?';
    return url + separator + 'token=' + encodeURIComponent(token);
  }
}
